export function StoreUser(data) {
  localStorage.clear();
  localStorage.setItem("userid", data.userid);
  localStorage.setItem("useremail", data.useremail);
  localStorage.setItem("customerid", data.customerid);
  localStorage.setItem("requestorid", data.requestorid);
  localStorage.setItem("userrole", data.userrole);
  localStorage.setItem("usertoken", data.usertoken);
  localStorage.setItem("customerlogo", data.customerlogo);
  window.logo = data.customerlogo;
  window.token = data.usertoken;
}

export function LogoutUser() {
  localStorage.clear();
  window.location.href = "/";
}

export function GetLocalUser() {
  const data = {
    customerlogo:
      window.logo == null
        ? localStorage.getItem("customerlogo") == null ||
          localStorage.getItem("customerlogo") === "null"
          ? ""
          : localStorage.getItem("customerlogo")
        : window.logo,
    userid:
      localStorage.getItem("userid") == null ||
      localStorage.getItem("userid") === "null"
        ? "0"
        : localStorage.getItem("userid"),
    useremail:
      localStorage.getItem("useremail") == null ||
      localStorage.getItem("useremail") === "null"
        ? "0"
        : localStorage.getItem("useremail"),
    customerid:
      localStorage.getItem("customerid") == null ||
      localStorage.getItem("customerid") === "null"
        ? "0"
        : localStorage.getItem("customerid"),
    requestorid:
      localStorage.getItem("requestorid") == null ||
      localStorage.getItem("requestorid") === "null"
        ? "0"
        : localStorage.getItem("requestorid"),
    usertoken: localStorage.getItem("usertoken"),
    userrole: localStorage.getItem("userrole")
  };

  return data;
  
}
